"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.busyStatuses = void 0;
var enums_1 = require("../enums");
/** Все статусы событий, которые считаются "занятым временем" */
exports.busyStatuses = [enums_1.EventStatusEnum.busy, enums_1.EventStatusEnum.day_off, enums_1.EventStatusEnum.course_reservations, enums_1.EventStatusEnum.ongoing_reservations, enums_1.EventStatusEnum.accept_required, enums_1.EventStatusEnum.cancel_required,
// EventStatusEnum.canceled,
enums_1.EventStatusEnum.reschedule_required, enums_1.EventStatusEnum.accepted, enums_1.EventStatusEnum.started, enums_1.EventStatusEnum.finished];
